import React from 'react';
import { CONTACTO } from '../../constants';
import './Whatsapp.css';

const Whatsapp = () => {
    const mensaje = '¡Hola! Quiero más información.';
    const link = `https://wa.me/${CONTACTO.WHATSAPP_NUMERO}?text=${encodeURIComponent(mensaje)}`;

    return (
        <a
            href={link}
            className="boton-wsp"
            target="_blank"
            rel="noopener noreferrer"
        >
            <img
                src="https://cdn-icons-png.flaticon.com/512/733/733585.png"
                alt="WhatsApp"
            />
        </a>
    );
};

export default Whatsapp;
